/*! Wi-carousel - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

+function ($) {
    'use strict';
    var wiCarousel = window.wiCarousel;
    window.wiCarousel = {
        init: function () {
            if ($(".carousel").length) {
                $(".carousel .carousel-inner").swipe({
                    swipeLeft: function (n, i, a, t, e) {
                        this.parent().carousel("next");
                    },
                    swipeRight: function () {
                        this.parent().carousel("prev");
                    },
                    threshold: 0
                });
                $(".carousel").each(function () {
                    var $myCarousel = $(this);
                    var $firstAnimatingElems = $myCarousel.find('.item:first').find('[data-animation ^= "animated"]');
                    wiAnimation.doAnimation($firstAnimatingElems);
                    $myCarousel.carousel('pause');
                    $myCarousel.on('slide.bs.carousel', function (e) {
                        var $animatingElems = $(e.relatedTarget).find("[data-animation ^= 'animated']");
                        wiAnimation.doAnimation($animatingElems);
                    });

                });
            }
        }
    };
    $(function () {
        wiCarousel = window.wiCarousel;
        wiCarousel.init();
    });
}(jQuery);
